import React from "react";
import EventListPageContainer from "./EventListPageContainer";

export class EventListPage extends React.Component {
  render() {
    return <EventListPageContainer {...this.props} />;
  }
}
